import React from 'react';

const PILLARS = [
  {
    num: '01',
    title: 'Prakriti — Your Unique Nature',
    body: 'No two bodies are the same. Ayurveda begins by understanding your individual constitution — the unique blend of Vata, Pitta, and Kapha you were born with. At KayaSparsha, every consultation starts here.',
  },
  {
    num: '02',
    title: 'Nidana — Root-Cause Diagnosis',
    body: 'Symptoms are signals, not the disease. Through Nadi Pariksha (pulse diagnosis) and deep intake, our physicians trace illness to its origin — dietary, lifestyle, emotional, or environmental.',
  },
  {
    num: '03',
    title: 'Chikitsa — Personalised Healing',
    body: 'Treatment is never one-size-fits-all. Every therapy plan — oils, herbs, procedures, and diet — is prescribed to restore the specific imbalance identified in your constitution.',
  },
  {
    num: '04',
    title: 'Rasayana — Rejuvenation & Prevention',
    body: 'Ayurveda does not end at curing disease. Rasayana therapies rebuild tissues, slow ageing, and strengthen immunity — a commitment to thriving, not just surviving.',
  },
];

export default function PhilosophySection() {
  return (
    <section className="philosophy-section" id="philosophy">
      {/* Full-width banner quote */}
      <div className="philosophy-banner">
        <div className="philosophy-banner-line" />
        <blockquote className="philosophy-quote fade-up">
          <span className="quote-mark">"</span>
          Swasthasya swāsthya rakṣaṇaṁ, āturasya vikāra praśamanaṁ ca.
          <span className="quote-mark">"</span>
          <cite>— Charaka Samhitā</cite>
        </blockquote>
        <p className="philosophy-quote-trans fade-up">
          To preserve the health of the healthy, and to cure the disease of the diseased.
          <br /><em>The dual purpose of Āyurveda.</em>
        </p>
        <div className="philosophy-banner-line" />
      </div>

      <div className="container">
        {/* Section header */}
        <div className="philosophy-header fade-up">
          <p className="section-label">Our Foundation</p>
          <h2 className="section-title">The KayaSparsha <em>Philosophy</em></h2>
          <p className="philosophy-intro">
            We practice Ayurveda as it was always intended — as a complete science of life,
            not a menu of massages. Every interaction at the clinic is guided by four
            foundational principles drawn from classical Ayurvedic texts.
          </p>
        </div>

        {/* Pillars grid */}
        <div className="philosophy-grid">
          {PILLARS.map((p) => (
            <div key={p.num} className="philosophy-card fade-up">
              <div className="philosophy-card-num">{p.num}</div>
              <h3 className="philosophy-card-title">{p.title}</h3>
              <p className="philosophy-card-body">{p.body}</p>
            </div>
          ))}
        </div>

        {/* Bottom manifesto strip */}
        <div className="philosophy-manifesto fade-up">
          <div className="philosophy-manifesto-inner">
            <div className="philosophy-manifesto-left">
              <p className="philosophy-manifesto-label">What We Believe</p>
              <h3 className="philosophy-manifesto-heading">
                Healing is not a product.<br /><em>It is a process.</em>
              </h3>
            </div>
            <div className="philosophy-manifesto-right">
              <p>
                We use only premium, classically-prepared Ayurvedic medicines from
                authentic sources. No shortcuts, no synthetic
                substitutes — because genuine healing demands genuine ingredients.
              </p>
              <div className="philosophy-badges">
                <span className="phil-badge">AYUSH Registered</span>
                <span className="phil-badge">BAMS Qualified Physicians</span>
                <span className="phil-badge">Classical Formulations Only</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
